export default __webpack_public_path__ + "static/laura kinnel-aceb4c34f6dfca676f9bc5de1fc2e797.png";